/**
 * Mobile product card image cycling
 * Replicates the desktop hover effect automatically on mobile
 * Random interval per card, minimum 5 seconds
 */
(function() {
  var MIN_DELAY = 5000;
  var MAX_DELAY = 10000;
  var MOBILE_BREAKPOINT = 1025;

  function randomDelay() {
    return MIN_DELAY + Math.random() * (MAX_DELAY - MIN_DELAY);
  }

  function preloadImages(container) {
    var imgs = container.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].loading === 'lazy') {
        imgs[i].loading = 'eager';
      }
      /* Force browser to start loading the image */
      if (imgs[i].dataset.src) {
        imgs[i].src = imgs[i].dataset.src;
      }
    }
  }

  function initCard(wrapper) {
    if (wrapper.dataset.cycleInit) return;
    var defaultImg = wrapper.querySelector('.product-card-default-image');
    var revealImg = wrapper.querySelector('.product-card-reveal-image');
    if (!defaultImg || !revealImg) return;
    if (!revealImg.querySelector('img')) return;

    wrapper.dataset.cycleInit = 'true';

    /* Preload reveal images so they're ready when we fade to them */
    preloadImages(revealImg);

    var showing = 'default';
    var timerId = null;

    function toggle() {
      /* Stop if resized to desktop */
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        defaultImg.style.opacity = '';
        revealImg.style.opacity = '';
        showing = 'default';
        /* Keep checking in case user goes back to mobile */
        timerId = setTimeout(function() {
          if (window.innerWidth < MOBILE_BREAKPOINT) toggle();
          else timerId = setTimeout(arguments.callee, 2000);
        }, 2000);
        return;
      }

      if (showing === 'default') {
        defaultImg.style.opacity = '0';
        revealImg.style.opacity = '1';
        showing = 'reveal';
      } else {
        defaultImg.style.opacity = '1';
        revealImg.style.opacity = '0';
        showing = 'default';
      }

      timerId = setTimeout(toggle, randomDelay());
    }

    /* Start with a random initial delay (5-13s) so cards don't all switch at once */
    var initialDelay = MIN_DELAY + Math.random() * 8000;
    timerId = setTimeout(toggle, initialDelay);
  }

  function initAll() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var wrappers = document.querySelectorAll('.card-product--image-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      initCard(wrappers[i]);
    }
  }

  /* Run after page + images load */
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  /* Also run after short delays for dynamically loaded content */
  [1000, 3000, 5000].forEach(function(t) {
    setTimeout(initAll, t);
  });

  /* Init for dynamically loaded cards (e.g. AJAX pagination) */
  var observerTimer = null;
  new MutationObserver(function() {
    if (observerTimer) return;
    observerTimer = setTimeout(function() {
      observerTimer = null;
      if (window.innerWidth < MOBILE_BREAKPOINT) initAll();
    }, 500);
  }).observe(document.body, { childList: true, subtree: true });
})();
